import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Heart, Users, Calendar, Gift } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function Adhesion() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: Heart,
      title: t('adhesion.benefit1'),
      description: t('adhesion.benefit1Desc')
    },
    {
      icon: Calendar,
      title: t('adhesion.benefit2'),
      description: t('adhesion.benefit2Desc')
    },
    {
      icon: Users,
      title: t('adhesion.benefit3'),
      description: t('adhesion.benefit3Desc')
    },
    {
      icon: Gift,
      title: "Tarifs préférentiels",
      description: "Bénéficiez de réductions sur certains événements"
    }
  ];

  return (
    <div className="min-h-screen pt-24" data-testid="adhesion-page">
      {/* Header */}
      <section className="py-16 bg-gradient-to-br from-fuchsia-500/10 via-transparent to-lime-500/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-fuchsia-500 mb-6 transition-colors">
            <ArrowLeft className="h-4 w-4" />
            {t('footerExt.home')}
          </Link>
          <div className="text-center">
            <span className="text-sm font-medium uppercase tracking-widest text-fuchsia-500 mb-4 block">
              {t('adhesion.subtitle')}
            </span>
            <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold mb-6">
              {t('adhesion.subtitle')}
            </h1>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
              {t('adhesion.heroDesc')}
            </p>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-center mb-12">
            {t('adhesion.why')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {benefits.map((benefit, index) => (
              <Card key={index} className="group hover:-translate-y-2 transition-all duration-300" data-testid={`benefit-card-${index}`}>
                <CardContent className="p-6 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-gradient-to-br from-fuchsia-500/20 to-lime-500/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <benefit.icon className="h-7 w-7 text-fuchsia-500" />
                  </div>
                  <h3 className="font-['Playfair_Display'] text-lg font-bold mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* HelloAsso Widget */}
      <section className="py-16 bg-muted/30" data-testid="helloasso-widget-section">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="text-center mb-8">
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold mb-4">
              {t('adhesion.joinNow')}
            </h2>
            <p className="text-muted-foreground">
              {t('adhesion.helloAssoInfo')}
            </p>
          </div>
          
          <Card className="overflow-hidden shadow-xl">
            <CardContent className="p-0">
              <iframe
                id="haWidget"
                allowTransparency="true"
                scrolling="auto"
                src="https://www.helloasso.com/associations/brious-o-folies/adhesions/adhesion-2026/widget"
                style={{ width: '100%', height: '750px', border: 'none' }}
                title="Formulaire d'adhésion HelloAsso"
                data-testid="helloasso-iframe"
              />
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-['Playfair_Display'] text-2xl font-bold mb-4">
            {t('adhesion.questions')}
          </h2>
          <p className="text-muted-foreground mb-6">
            {t('adhesion.heroDesc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button className="btn-primary" data-testid="adhesion-contact-btn">
                {t('adhesion.contactUs')}
              </Button>
            </Link>
            <a href="tel:+33749513090">
              <Button variant="outline" className="btn-secondary" data-testid="adhesion-phone-btn">
                07 49 51 30 90
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
